import React, { FC } from "react"

import Page from "../components/layouts/page/Page"
import { useLanguage } from "../contexts/language-context"
import AppearanceSettingsCard from "../features/settings/appearance-settings-card/AppearanceSettingsCard"
import UsersSettingsCard from "../features/settings/users-settings-card/UsersSettingsCard"
import SyncSettingsCard from "../features/settings/sync-settings-card/SyncSettingsCard"
import SuperAdminSettingsCard from "../features/settings/super-admin-settings-card/SuperAdminSettingsCard"
import { useAuth } from "../contexts/authentication-context"

const Settings: FC = () => {
    const { L } = useLanguage()
    const { user } = useAuth()

    return (
        <Page title={L("Settings")}>
            <AppearanceSettingsCard />
            <UsersSettingsCard />
            {user?.isSuper && <SuperAdminSettingsCard />}
            <SyncSettingsCard />
        </Page>
    )
}

export default Settings
